import React from 'react';

interface PageLayoutProps {
  title: string;
  subtitle?: string;
  bgColor: string;
  textColor: string;
  borderColor: string;
  icon: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = (props) => {
  const { children, className = '' } = props;
  return (
    <div className={`space-y-8 ${className}`}>
      {children}
    </div>
  );
};
